<template>
  <div>
    <div id="recaptcha-container" />
  </div>
</template>

<script>
export default {
  emits: ['validate', 'error'],
  mounted() {
    this.loadReCaptcha();
  },
  methods: {
    loadReCaptcha() {
      if (window.grecaptcha) {
        window.grecaptcha.render('recaptcha-container', {
          sitekey: '6Le3IeIgAAAAADAr_03dYa5WF7QrEyea1e8i8mS0',
          callback: this.onRecaptchaSuccess,
          'expired-callback': this.onRecaptchaExpired,
        });
      }
    },
    onRecaptchaSuccess(response) {
      this.$emit('validate', response);
    },
    onRecaptchaExpired() {
      this.$emit('error');
    },
  },
};
</script>

<style scoped lang="scss"></style>
